define('customPlugins/atnAccordionScrollbar',['lodash', './utils', 'knockout', 'jquery', './atnKoScrollbar'],
    function(_, utils, ko, $) {
        'use strict';

        ko.bindingHandlers.atnAccordionScrollbar = {
            init: function(element, valueAccessor) {
                if (!utils.isInternetExplorer()) {
                    // adding subscription on the valueAccessor provided;
                    // scroll the scrollbar to the given position.
                    var scrollingSubscription = ko.computed(function() {
                        var scrollBarPosition = ko.utils.unwrapObservable(valueAccessor().scrollBarPosition);
                        element.scrollTop = scrollBarPosition;
                        $(element).perfectScrollbar('update');
                    });

                    // initializing atnKoScrollbar
                    ko.bindingHandlers.atnKoScrollbar.init(element, function() {
                        return valueAccessor().options;
                    });

                    // adding handler for disposal
                    ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                        // disposing scrollingSubscription
                        scrollingSubscription.dispose();
                    });
                }
            }
        };
    });

